import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  'start.learning': {
    id: 'start.learning',
    defaultMessage: 'Start learning',
    description: 'Header text for logistration MFE pages',
  },
  'with.site.name': {
    id: 'with.site.name',
    defaultMessage: 'with {siteName}',
    description: 'Header text with site name for logistration MFE pages',
  },
  'with.polish.site.name': {
    id: 'with.polish.site.name',
    defaultMessage: 'z Edumedo Online',
    description: "Header text with site name for logistration MFE pages. Polish conjugated custom name."}
});

export default messages;
